import { defineComponent, inject, onMounted, PropType, ref } from "vue";
import { Image } from "@/interfaces/Image";

import gsap from "gsap";
import {
  showUIAndRestOfPage,
  animateTransitionImages,
} from "@/shared-animations/hero";
export default defineComponent({
  props: {
    title: { type: String, required: true },
    introduction: { type: String, required: false },
    images: { type: Array as PropType<Image[]>, required: false },
    image: { type: String, required: false },
    date: { type: String, required: true },
    date2: { type: String, required: false },
  },
  setup() {
    const emitter = inject("emitter");
    const heroRef = ref<HTMLElement | null>(null);

    onMounted(() => {
      const heroTL = gsap.timeline({ delay: 0.75 });

      const imageContainers = heroRef.value!.querySelectorAll(
        ".transition_image__container"
      );

      animateTransitionImages(heroTL, imageContainers);

      heroTL
        .add(function () {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore:next-line
          emitter.emit("pagewrapper-background-animation--stop", 3);
        }, "-=0.5")
        .addLabel("going-down-finished", "+=1.5")
        .from(
          ".hero__container, .pagecontainer section",
          {
            autoAlpha: 0,
            y: 200,
            duration: 1.6,
            ease: "power4.out",
          },
          "going-down-finished-=1.25"
        );
      heroTL.addLabel("showUI", "going-down-finished-=1");
      showUIAndRestOfPage(heroTL);
    });

    return { heroRef };
  },
});
